import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classnames from 'classnames';
import TableHeader from './TableHeader/TableHeader_component';
import TableBody from './TableBody/TableBody_component';
import LoadingLayer from './LoadingLayer/LoadingLayerComponent';
import CorruptTableLayer from './CorruptTableLayer';
import styles from './styles.scss'; // eslint-disable-line

const TableComponent = (props) => {
	//console.log(props.filters[0], "\n");
	if (!props.header) {
		return (
			<div styleName="QualTable" className="grey analytics">
				<CorruptTableLayer show={true} />
			</div>
		);
	}


	return (
		<div styleName="QualTable" className="grey analytics">
			<TableHeader
				{...props}
				cols={props.header}
			/>
			<TableBody
				{...props}
				rows={props.data}
				cols={props.header}
				viewMoreStr={props.translations.viewMore}
			/>
			<LoadingLayer loadingStr={props.translations.loadingStr} show={props.withLoadingLayer && props.loadingData} />
		</div>
	);
};

TableComponent.displayName = 'TableComponent';

TableComponent.propTypes = {
	header: PropTypes.array,
	data: PropTypes.array.isRequired,
	filters: PropTypes.arrayOf(PropTypes.object).isRequired,
	width: PropTypes.number,
	getData: PropTypes.func,
	getFilter: PropTypes.func,
	withLoadingLayer: PropTypes.bool,
	loadingData: PropTypes.bool,
	questionId: PropTypes.string,
	hasMoreData: PropTypes.bool,
	translations: PropTypes.object
};


export default CSSModules(TableComponent, styles);



// WEBPACK FOOTER //
// ./components/qual/Table/Table_component.js